module.exports = __webpack_public_path__ + "static/bearing-553d63aed3ef29390634b0706125265e.mp4";